// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>17</span>&nbsp;&nbsp;The Lord shall reign for ever and ever;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the nations shall perish from his land.<br> </p> </div></div>";
// Exports
module.exports = code;